import { ERROR_PART } from "../hub-table.constants";
import { useHubTableContext } from "../hub-table.context";
import type { HubTableSlotProps } from "../types-hub-table";

/** Conteúdo do erro de carregamento (padrão: `ErrorState`). O Root decide quando mostrar; fora dele, erro. */
export function HubTableErrorMessage({ children }: HubTableSlotProps) {
  useHubTableContext();
  return <>{children}</>;
}
HubTableErrorMessage.displayName = ERROR_PART;
